import * as React from 'react';
import {
  makeStyles
} from '@material-ui/core';
import theme from '../../theme';
import { Table, TableCell, TableBody, TableRow } from '@material-ui/core';

const useStyles = makeStyles((th) => ({
  table: {
    fontFamily: theme.fontFamily.MARKPROBOLD,
    transition: "backgroundColor .3s ease-in, color .3s ease-in"
  },
  tableRow: {
    border: `2px solid ${theme.colors.DodgerBlue}`,
    borderRadius: `20px`,
    WebkitBorderRadius: "20px",
    borderCollapse: 'separate',
    borderSpacing: 0,
    overflow: 'hidden',
    maxWidth: "max-content",
  },
  cell: {
    padding: '4px 8px',
    textAlign: 'center',
    whiteSpace: 'nowrap'
  }
}));


function CommonTab({
  choices = [
    { value: "Tab 1", label: "Tab 1" },
    { value: "Tab 2", label: "Tab 2" }
  ],
  onColClick
}) {
  const classes = useStyles()
  const [label, setLabel] = React.useState(choices?.length >= 1 ? choices[0].label : "")
  return (
    <Table className={classes.table}>
      <TableBody>
        <TableRow className={classes.tableRow}>
          {
            choices?.length >= 1 ? (
              <React.Fragment>
                {
                  choices.map((data, index) => (
                    <TableCell
                      key={index}
                      className={classes.cell}
                      style={{
                        backgroundColor: data.label === label ? theme.colors.DodgerBlueLight : "",
                        cursor: "pointer",
                        color: data.label === label ? theme.colors.White : ""
                      }}
                      onClick={(e) => {
                        if (onColClick) {
                          onColClick(data)
                        }
                        setLabel(data.label)
                      }}
                    >
                      {data?.label}
                    </TableCell>
                  ))
                }
              </React.Fragment>
            ) : null
          }
        </TableRow>
      </TableBody>
    </Table>
  )
}

export default CommonTab;